import { render, staticRenderFns } from "./jzwList.vue?vue&type=template&id=f14f83d4&scoped=true"
import script from "./jzwList.vue?vue&type=script&lang=js"
export * from "./jzwList.vue?vue&type=script&lang=js"
import style0 from "./jzwList.vue?vue&type=style&index=0&id=f14f83d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14f83d4",
  null
  
)

export default component.exports